import React, { useState } from "react";

function formatDuration(seconds) {
  const m = Math.floor(seconds / 60)
    .toString()
    .padStart(2, "0");
  const s = Math.floor(seconds % 60)
    .toString()
    .padStart(2, "0");
  return `${m}:${s}`;
}

const VideoGallery = ({ videos }) => {
  const [activeVideo, setActiveVideo] = useState(videos[0]);

  return (
    <div className="video-gallery">
      <div className="main-video">
        <video
          src={activeVideo.url}
          poster={activeVideo.thumbnail}
          controls
          autoPlay
          muted
          style={{ width: "100%", maxWidth: "850px", maxHeight: "450px", borderRadius: "12px" }}
        />
        <div className="main-video-info">
          <h2>{activeVideo.title}</h2>
          <p>{activeVideo.description}</p>
        </div>
      </div>

      { }
      <div className="thumbnails">
        {videos.map((video) => (
          <div
            key={video.id}
            className={`thumb ${activeVideo.id === video.id ? "active" : ""}`}
            onClick={() => setActiveVideo(video)}
          >
            <div className="thumb-img-wrapper">
              <img
                src={video.thumbnail}
                alt={video.title}
                className="thumb-img"
              />
              <span className="duration">{formatDuration(video.duration)}</span>
              <span className="play-icon">&#9658;</span>
            </div>
            <div className="thumb-title">{video.title}</div>
          </div>
        ))}
      </div>

      { }
      <style jsx>{`
        .video-gallery {
          max-width: 900px;
          margin: 0 auto;
          font-family: Inter, Arial, sans-serif;
        }
        .main-video {
          background:rgb(27, 27, 27);
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          margin-bottom: 32px;
          padding: 24px;
        }
        .main-video-info h2 {
          margin: 16px 0 8px 0;
          font-size: 1.5rem;
        }
        .main-video-info p {
          color: #ddd;
        }
        .thumbnails {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
          gap: 20px;
        }
        .thumb {
          cursor: pointer;
          background: #222;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.04);
          transition: box-shadow 0.2s, transform 0.2s;
          overflow: hidden;
          border: 2px solid transparent;
        }
        .thumb.active {
          border: 2px solid rgb(81, 235, 127);
          box-shadow: 0 4px 16px rgba(0, 243, 53, 0.08);
          transform: scale(1.03);
        }
        .thumb-img-wrapper {
          position: relative;
        }
        .thumb-img {
          width: 100%;
          display: block;
          aspect-ratio: 16/9;
          object-fit: cover;
        }
        .duration {
          position: absolute;
          bottom: 8px;
          right: 8px;
          background: rgba(0,0,0,0.7);
          color: #fff;
          font-size: 0.85rem;
          padding: 2px 8px;
          border-radius: 4px;
        }
        .play-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 2.2rem;
          color: rgba(255,255,255,0.85);
          pointer-events: none;
          text-shadow: 0 2px 8px rgba(0,0,0,0.3);
        }
        .thumb-title {
          padding: 10px 12px;
          font-size: 1rem;
          font-weight: 500;
          color: rgb(201, 201, 201);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
    </div>
  );
};

export default VideoGallery;
